var _excluded = ["attributes", "children", "nodeProps", "styles", "element", "classNames", "prefixClassNames", "resizableProps"],
  _excluded2 = ["attributes", "children", "nodeProps", "styles", "element", "classNames", "prefixClassNames", "transformColSizes", "onRenderContainer"],
  _excluded3 = ["attributes", "children", "nodeProps", "styles", "element", "classNames", "prefixClassNames"],
  _excluded4 = ["transform", "header"];
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { atom, useAtom, Provider } from 'jotai';
import { createStyles } from '@udecode/plate-styled-components';
import _styled, { css } from 'styled-components';
import React, { useMemo } from 'react';
import { useEditorRef, useStoreEditorState, useEventEditorId, getPlatePluginType } from '@udecode/plate-core';
import { ELEMENT_TABLE, getTableColumnIndex, setTableColSize, getTableColumnCount } from '@udecode/plate-table';
import { Resizable } from 're-resizable';
import { ReactEditor } from 'slate-react';
import { withProviders, someNode, getPreventDefaultHandler } from '@udecode/plate-common';
import { RemoveNodeButton } from '@udecode/plate-ui-button';
import { Popover } from '@udecode/plate-ui-popover';
import { ToolbarButton } from '@udecode/plate-toolbar';
var hoveredColIndexAtom = atom(null);
var resizingColAtom = atom(null);
var getTableCellElementStyles = function getTableCellElementStyles(props) {
  var hovered = props.hovered,
    hideBorder = props.hideBorder;
  return createStyles(_objectSpread({
    prefixClassNames: 'TableCellElement'
  }, props), {
    root: [{
      "position": "relative",
      "padding": "0px",
      "overflow": "visible",
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgba(255, 255, 255, var(--tw-bg-opacity))"
    }, hideBorder ? {
      "borderStyle": "none"
    } : {
      "borderWidth": "1px",
      "--tw-border-opacity": "1",
      "borderColor": "rgba(209, 213, 219, var(--tw-border-opacity))"
    }, css(["min-width:48px;"])],
    content: {
      "position": "relative",
      "paddingLeft": "0.75rem",
      "paddingRight": "0.75rem",
      "paddingTop": "0.5rem",
      "paddingBottom": "0.5rem",
      "zIndex": "10"
    },
    resizableWrapper: [{
      "position": "absolute",
      "width": "100%",
      "height": "100%",
      "top": "0px"
    }],
    handle: [{
      "position": "absolute"
    }, hovered && {
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgba(59, 130, 246, var(--tw-bg-opacity))"
    }, css(["top:-12px;right:-2px;width:4px;height:calc(100% + 12px);z-index:10;"])]
  });
};
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function toVal(mix) {
  var k,
    y,
    str = '';
  if (typeof mix === 'string' || typeof mix === 'number') {
    str += mix;
  } else if (_typeof(mix) === 'object') {
    if (Array.isArray(mix)) {
      for (k = 0; k < mix.length; k++) {
        if (mix[k]) {
          if (y = toVal(mix[k])) {
            str && (str += ' ');
            str += y;
          }
        }
      }
    } else {
      for (k in mix) {
        if (mix[k]) {
          str && (str += ' ');
          str += k;
        }
      }
    }
  }
  return str;
}
function clsx() {
  var i = 0,
    tmp,
    x,
    str = '';
  while (i < arguments.length) {
    if (tmp = arguments[i++]) {
      if (x = toVal(tmp)) {
        str && (str += ' ');
        str += x;
      }
    }
  }
  return str;
}
var TableCellElement = function TableCellElement(props) {
  var attributes = props.attributes,
    children = props.children,
    nodeProps = props.nodeProps,
    styles = props.styles,
    element = props.element,
    classNames = props.classNames,
    prefixClassNames = props.prefixClassNames,
    resizableProps = props.resizableProps,
    rootProps = _objectWithoutProperties(props, _excluded);
  var editor = useEditorRef();
  var _useAtom = useAtom(hoveredColIndexAtom, ELEMENT_TABLE),
    _useAtom2 = _slicedToArray(_useAtom, 2),
    hoveredColIndex = _useAtom2[0],
    setHoveredColIndex = _useAtom2[1];
  var _useAtom3 = useAtom(resizingColAtom, ELEMENT_TABLE),
    _useAtom4 = _slicedToArray(_useAtom3, 2),
    setResizingCol = _useAtom4[1];
  var colIndex = useMemo(function () {
    return getTableColumnIndex(editor, {
      node: element
    });
  }, [editor, element]);
  var _getTableCellElementS = getTableCellElementStyles(_objectSpread(_objectSpread({}, props), {}, {
      hovered: hoveredColIndex === colIndex
    })),
    root = _getTableCellElementS.root,
    content = _getTableCellElementS.content,
    resizableWrapper = _getTableCellElementS.resizableWrapper,
    resizable = _getTableCellElementS.resizable,
    handle = _getTableCellElementS.handle;
  var onResize = function onResize(e, direction, ref) {
    setResizingCol({
      index: colIndex,
      width: ref.offsetWidth
    });
  };
  var onResizeStop = function onResizeStop(e, direction, ref) {
    setTableColSize(editor, {
      colIndex: colIndex,
      width: ref.offsetWidth
    }, {
      at: ReactEditor.findPath(editor, element)
    });
    setResizingCol(null);
  };
  return /*#__PURE__*/React.createElement(_StyledTd, _extends({}, attributes, {
    className: root.className
  }, rootProps, nodeProps, {
    $_css: root.css
  }), /*#__PURE__*/React.createElement(_StyledDiv, {
    className: content === null || content === void 0 ? void 0 : content.className,
    $_css2: content === null || content === void 0 ? void 0 : content.css
  }, children), /*#__PURE__*/React.createElement(_StyledDiv2, {
    className: clsx(resizableWrapper === null || resizableWrapper === void 0 ? void 0 : resizableWrapper.className, 'group'),
    contentEditable: false,
    onMouseOver: function onMouseOver() {
      return setHoveredColIndex(colIndex);
    },
    onFocus: function onFocus() {
      return setHoveredColIndex(colIndex);
    },
    onMouseOut: function onMouseOut() {
      return setHoveredColIndex(null);
    },
    onBlur: function onBlur() {
      return setHoveredColIndex(null);
    },
    $_css3: resizableWrapper === null || resizableWrapper === void 0 ? void 0 : resizableWrapper.css
  }, /*#__PURE__*/React.createElement(_StyledResizable, _extends({
    className: resizable === null || resizable === void 0 ? void 0 : resizable.className,
    size: {
      width: '100%',
      height: '100%'
    },
    enable: {
      right: true
    },
    handleStyles: {
      right: {
        top: -12,
        height: 'calc(100% + 12px)',
        zIndex: 20
      }
    },
    onResize: onResize,
    onResizeStop: onResizeStop
  }, resizableProps, {
    $_css4: resizable === null || resizable === void 0 ? void 0 : resizable.css
  })), /*#__PURE__*/React.createElement(_StyledDiv3, {
    className: handle === null || handle === void 0 ? void 0 : handle.className,
    $_css5: handle === null || handle === void 0 ? void 0 : handle.css
  })));
};
var _StyledTd = _styled("td").withConfig({
  displayName: "TableCellElement___StyledTd",
  componentId: "sc-1b15v56-0"
})(["", ""], function (p) {
  return p.$_css;
});
var _StyledDiv = _styled("div").withConfig({
  displayName: "TableCellElement___StyledDiv",
  componentId: "sc-1b15v56-1"
})(["", ""], function (p) {
  return p.$_css2;
});
var _StyledDiv2 = _styled("div").withConfig({
  displayName: "TableCellElement___StyledDiv2",
  componentId: "sc-1b15v56-2"
})(["", ""], function (p) {
  return p.$_css3;
});
var _StyledResizable = _styled(Resizable).withConfig({
  displayName: "TableCellElement___StyledResizable",
  componentId: "sc-1b15v56-3"
})(["", ""], function (p) {
  return p.$_css4;
});
var _StyledDiv3 = _styled("div").withConfig({
  displayName: "TableCellElement___StyledDiv3",
  componentId: "sc-1b15v56-4"
})(["", ""], function (p) {
  return p.$_css5;
});
var getTableElementStyles = function getTableElementStyles(props) {
  return createStyles(_objectSpread({
    prefixClassNames: 'TableElement'
  }, props), {
    root: [{
      "display": "table",
      "width": "100%",
      "marginTop": "1rem",
      "marginBottom": "1rem",
      "marginLeft": "0px",
      "marginRight": "0px",
      "borderCollapse": "collapse"
    }],
    tbody: {
      "minWidth": "100%"
    }
  });
};
var useTableColSizes = function useTableColSizes(tableNode) {
  var _useAtom5 = useAtom(resizingColAtom, ELEMENT_TABLE),
    _useAtom6 = _slicedToArray(_useAtom5, 1),
    resizingCol = _useAtom6[0];
  var colCount = getTableColumnCount(tableNode);
  var colSizes = tableNode.colSizes ? _toConsumableArray(tableNode.colSizes) : Array(colCount);
  if (resizingCol) {
    var _resizingCol$index;
    colSizes[(_resizingCol$index = resizingCol.index) !== null && _resizingCol$index !== void 0 ? _resizingCol$index : 0] = resizingCol.width;
  }
  return colSizes;
};
var TablePopover = function TablePopover(_ref) {
  var element = _ref.element,
    popoverProps = _ref.popoverProps,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(Popover, _extends({
    content: /*#__PURE__*/React.createElement(RemoveNodeButton, {
      element: element
    })
  }, popoverProps), children);
};
var TableElementBase = function TableElementBase(props) {
  var attributes = props.attributes,
    children = props.children,
    nodeProps = props.nodeProps,
    styles = props.styles,
    element = props.element,
    classNames = props.classNames,
    prefixClassNames = props.prefixClassNames,
    transformColSizes = props.transformColSizes,
    _props$onRenderContai = props.onRenderContainer,
    Popover = _props$onRenderContai === void 0 ? TablePopover : _props$onRenderContai,
    rootProps = _objectWithoutProperties(props, _excluded2);
  var _getTableElementStyle = getTableElementStyles(props),
    root = _getTableElementStyle.root,
    tbody = _getTableElementStyle.tbody;
  var colSizes = useTableColSizes(element);
  if (transformColSizes) {
    colSizes = transformColSizes(colSizes);
  }
  return /*#__PURE__*/React.createElement(Popover, props, /*#__PURE__*/React.createElement(_StyledTable, _extends({}, attributes, {
    className: root.className
  }, rootProps, nodeProps, {
    $_css: root.css
  }), /*#__PURE__*/React.createElement("colgroup", null, colSizes.map(function (width, index) {
    return /*#__PURE__*/React.createElement("col", {
      key: index,
      style: width ? {
        width: width
      } : undefined
    });
  })), /*#__PURE__*/React.createElement(_StyledTbody, {
    className: tbody === null || tbody === void 0 ? void 0 : tbody.className,
    $_css2: tbody === null || tbody === void 0 ? void 0 : tbody.css
  }, children)));
};
var TableElement = withProviders([Provider, {
  scope: ELEMENT_TABLE
}])(TableElementBase);
var _StyledTable = _styled("table").withConfig({
  displayName: "TableElement___StyledTable",
  componentId: "sc-1g9mdxx-0"
})(["", ""], function (p) {
  return p.$_css;
});
var _StyledTbody = _styled("tbody").withConfig({
  displayName: "TableElement___StyledTbody",
  componentId: "sc-1g9mdxx-1"
})(["", ""], function (p) {
  return p.$_css2;
});
var getTableRowElementStyles = function getTableRowElementStyles(props) {
  return createStyles(_objectSpread({
    prefixClassNames: 'TableRowElement'
  }, props), {
    root: [props.hideBorder && {
      "borderStyle": "none"
    }]
  });
};
var TableRowElement = function TableRowElement(props) {
  var attributes = props.attributes,
    children = props.children,
    nodeProps = props.nodeProps,
    styles = props.styles,
    element = props.element,
    classNames = props.classNames,
    prefixClassNames = props.prefixClassNames,
    rootProps = _objectWithoutProperties(props, _excluded3);
  var _getTableRowElementSt = getTableRowElementStyles(props),
    root = _getTableRowElementSt.root;
  return /*#__PURE__*/React.createElement(_StyledTr, _extends({}, attributes, {
    className: root.className
  }, rootProps, nodeProps, {
    $_css: root.css
  }), children);
};
var _StyledTr = _styled("tr").withConfig({
  displayName: "TableRowElement___StyledTr",
  componentId: "sc-1c0uf2e-0"
})(["", ""], function (p) {
  return p.$_css;
});
var ToolbarTable = function ToolbarTable(_ref2) {
  var transform = _ref2.transform,
    header = _ref2.header,
    props = _objectWithoutProperties(_ref2, _excluded4);
  var editor = useStoreEditorState(useEventEditorId('focus'));
  var type = getPlatePluginType(editor, ELEMENT_TABLE);
  return /*#__PURE__*/React.createElement(ToolbarButton, _extends({
    active: !!(editor !== null && editor !== void 0 && editor.selection) && someNode(editor, {
      match: {
        type: type
      }
    }),
    onMouseDown: !!type && editor ? getPreventDefaultHandler(transform, editor, {
      header: header
    }) : undefined
  }, props));
};
export { TableCellElement, TableElement, TableElementBase, TablePopover, TableRowElement, ToolbarTable, getTableCellElementStyles, getTableElementStyles, getTableRowElementStyles, hoveredColIndexAtom, resizingColAtom, useTableColSizes };